import { render, staticRenderFns } from "./ConsultCard.vue?vue&type=template&id=7152f144&scoped=true"
import script from "./ConsultCard.vue?vue&type=script&lang=js"
export * from "./ConsultCard.vue?vue&type=script&lang=js"
import style0 from "./ConsultCard.vue?vue&type=style&index=0&id=7152f144&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7152f144",
  null
  
)

export default component.exports